import type { UnitType } from '@core/utils-legacy';

/**
 * Reduces one row of the dataset to the single value a total or a summary item
 * displays.
 *
 * Ratios are already reduced to a single value by the dataset, so they are
 * taken as they come. Every other unit type is summed, but a row without a
 * single numeric value stays `null` instead of collapsing to 0 — a rate comes
 * back as `null` when there is nothing to compute the percentage from, which
 * is not the same as 0% and has to render as the empty marker.
 */
export const reduceValues = (values: Array<number | null>, unitType: UnitType): number | null => {
  if (unitType === 'ratio') {
    return values[0] ?? null;
  }

  if (!values.some(value => typeof value === 'number')) {
    return null;
  }

  return values.reduce<number>((acc, value) => acc + (value ?? 0), 0);
};
